import { pipe, tap } from 'ramda'
import { EventHandler, SyntheticEvent } from 'react'

/**
 * useEventHooks
 * author: soojin.oh
 */

const stopPropagation = (e: SyntheticEvent) => e.stopPropagation()
const preventDefault = (e: SyntheticEvent) => e.preventDefault()
const runnable = (f?: EventHandler<SyntheticEvent>) => tap(f ? f : (e: SyntheticEvent) => void e)
const UNDEFINED = () => undefined

const stopAndPrevent = <T extends SyntheticEvent>(after?: EventHandler<T>) =>
  pipe(tap(stopPropagation), tap(preventDefault), runnable(after), UNDEFINED)

const stop = <T extends SyntheticEvent>(after?: EventHandler<T>) =>
  pipe(tap(stopPropagation), runnable(after), UNDEFINED)

const prevent = <T extends SyntheticEvent>(after?: EventHandler<T>) =>
  pipe(tap(preventDefault), runnable(after), UNDEFINED)

// hook
const useEventHooks = () => ({
  stop,
  prevent,
  stopAndPrevent,
})

export default useEventHooks
